import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export function Reveal({ children, delay = 0, y = 28, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-70px" }}
      transition={{ duration: 0.75, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function Eyebrow({ children }) {
  return (
    <p className="font-mono text-lg sm:text-xl font-bold uppercase tracking-[0.22em] text-ember" data-testid="section-eyebrow">
      {children}
    </p>
  );
}

export function SectionHead({ eyebrow, title, copy, center = false }) {
  return (
    <Reveal className={center ? "text-center" : ""}>
      {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
      <h2 className="mt-4 font-condensed text-3xl sm:text-4xl lg:text-5xl font-bold uppercase leading-[1.02] tracking-tight text-white">
        {title}
      </h2>
      {copy && (
        <p className={`mt-5 max-w-2xl text-base sm:text-lg leading-relaxed text-slate-400 ${center ? "mx-auto" : ""}`}>
          {copy}
        </p>
      )}
    </Reveal>
  );
}
